<div class="m-nexpeTable">
  <table class="m-nexpeTable__table">
    <thead class="m-nexpeTable__thead">
      <tr class="m-nexpeTable__headerRow">
        <th class="m-nexpeTable__th">{{ 'NEXPE.TABLE.NAME' | translate }}</th>
        <th class="m-nexpeTable__th">{{ 'NEXPE.TABLE.NEXPE' | translate }}</th>
        <th class="m-nexpeTable__th">{{ 'NEXPE.TABLE.DECLARATION' | translate }}</th>
        <th class="m-nexpeTable__th">{{ 'NEXPE.TABLE.DEGRADATION' | translate }}</th>
        <th class="m-nexpeTable__th">{{ 'NEXPE.TABLE.TROUBLESHOOTING' | translate }}</th>
        <th class="m-nexpeTable__th">{{ 'NEXPE.TABLE.QUALITY' | translate }}</th>
        <th class="m-nexpeTable__th">{{ 'NEXPE.TABLE.DELAY' | translate }}</th>
        <th class="m-nexpeTable__th">{{ 'NEXPE.TABLE.EVALUATION' | translate }}</th>
        <th class="m-nexpeTable__th">{{ 'NEXPE.TABLE.CONTACT' | translate }}</th>
        <th class="m-nexpeTable__th">{{ 'NEXPE.TABLE.CUTOFF' | translate }}</th>
      </tr>
    </thead>
    <tbody class="m-nexpeTable__tbody">
      @for (nexpe of nexpes(); track nexpe.nexpe) {
      <tr class="m-nexpeTable__row" (click)="onRowClick(nexpe.nexpe)">
        <td class="m-nexpeTable__td m-nexpeTable__td--name">{{ nexpe.name }}</td>
        <td class="m-nexpeTable__td m-nexpeTable__td--nexpe">{{ nexpe.nexpe }}</td>
        <td class="m-nexpeTable__td">
          <span
            [class.m-nexpeTable__badge--active]="nexpe.allowedNExpeDeclaration"
            class="m-nexpeTable__badge"
          >
            {{ nexpe.allowedNExpeDeclaration ? '✓' : '✗' }}
          </span>
        </td>
        <td class="m-nexpeTable__td">
          <span
            [class.m-nexpeTable__badge--active]="nexpe.allowedNexpeDegradation"
            class="m-nexpeTable__badge"
          >
            {{ nexpe.allowedNexpeDegradation ? '✓' : '✗' }}
          </span>
        </td>
        <td class="m-nexpeTable__td">
          <span
            [class.m-nexpeTable__badge--active]="nexpe.allowedNexpeTroubleshooting"
            class="m-nexpeTable__badge"
          >
            {{ nexpe.allowedNexpeTroubleshooting ? '✓' : '✗' }}
          </span>
        </td>
        <td class="m-nexpeTable__td">
          <span
            [class.m-nexpeTable__badge--active]="nexpe.allowedNexpeQuality"
            class="m-nexpeTable__badge"
          >
            {{ nexpe.allowedNexpeQuality ? '✓' : '✗' }}
          </span>
        </td>
        <td class="m-nexpeTable__td">
          <span
            [class.m-nexpeTable__badge--active]="nexpe.allowedNexpeDelay"
            class="m-nexpeTable__badge"
          >
            {{ nexpe.allowedNexpeDelay ? '✓' : '✗' }}
          </span>
        </td>
        <td class="m-nexpeTable__td">
          <span
            [class.m-nexpeTable__badge--active]="nexpe.allowedNExpeEvaluation"
            class="m-nexpeTable__badge"
          >
            {{ nexpe.allowedNExpeEvaluation ? '✓' : '✗' }}
          </span>
        </td>
        <td class="m-nexpeTable__td">
          <span [class.m-nexpeTable__badge--active]="nexpe.hasContact" class="m-nexpeTable__badge">
            {{ nexpe.hasContact ? '✓' : '✗' }}
          </span>
        </td>
        <td class="m-nexpeTable__td">
          <span
            [class.m-nexpeTable__badge--active]="nexpe.cutOffConfigured"
            class="m-nexpeTable__badge"
          >
            {{ nexpe.cutOffConfigured ? '✓' : '✗' }}
          </span>
        </td>
      </tr>
      } @empty {
      <tr>
        <td colspan="9" class="m-nexpeTable__empty">{{ 'NEXPE.TABLE.NO_RESULTS' | translate }}</td>
      </tr>
      }
    </tbody>
  </table>
</div>
